import { render, staticRenderFns } from "./SeguroMascotas.vue?vue&type=template&id=f21501b4&scoped=true&"
import script from "./SeguroMascotas.vue?vue&type=script&lang=js&"
export * from "./SeguroMascotas.vue?vue&type=script&lang=js&"
import style0 from "./SeguroMascotas.vue?vue&type=style&index=0&id=f21501b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21501b4",
  null
  
)

export default component.exports